export type IconProps = {
  color: string;
};
export const BoxIcon = ({ color }: IconProps) => {
  return (
    <svg width="27" height="23" viewBox="0 0 27 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.9626 17.1362L26.5471 13.183L16.7651 10.7144L19.6573 6.80772L25.0262 6.16364C25.6765 6.08551 26.5097 5.51112 26.518 4.78468C26.512 4.52088 26.4224 4.26609 26.2624 4.05825C25.8261 3.44796 25.1674 2.93059 24.6397 2.40265C24.112 1.87472 23.6175 1.21375 22.9214 0.888542C22.0793 0.535788 21.1606 0.414877 20.2578 0.537995L8.14883 1.48405C6.05448 1.48405 5.21716 3.15232 4.98653 3.56199L0.550597 11.6098C0.189199 12.2629 -0.000435458 12.9997 7.50846e-07 13.749V17.6683C0.00205269 17.889 0.0645779 18.1047 0.180556 18.2912C0.296534 18.4777 0.461372 18.6276 0.656561 18.7242L6.9853 22.0629C7.51828 22.4023 8.15003 22.5447 8.77422 22.4662L12.6741 21.9805L24.914 20.4157C26.2998 20.4157 26.8442 19.571 26.9751 18.2871C27.0114 17.9041 27.0073 17.5183 26.9626 17.1362ZM22.1194 1.48405L25.3794 5.03387L19.4225 5.66739C19.381 6.21855 18.7618 6.60922 18.1759 6.53531C17.7219 6.46783 17.3007 6.25561 16.9729 5.92924L12.1069 6.45295L8.14883 2.66662L22.1194 1.48405ZM9.34975 16.0571C8.87692 16.1225 8.39575 16.0377 7.97222 15.8142L1.62894 12.6065L15.8322 10.706L15.666 14.2959L17.696 14.9611L9.34975 16.0571Z"
        fill={color}
      />
    </svg>
  );
};

export const OneIcon = ({ color }: IconProps) => {
  return (
    <svg width="17" height="30" viewBox="0 0 17 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.2092 19.9954L12.4984 29.9993C8.0795 29.848 3.505 29.848 0 29.9047L0.0461824 21.5157C-0.0656277 19.1702 1.71604 16.2288 4.37518 16.1082L7.19474 15.9782C10.2574 15.4982 12.0974 17.6546 12.2092 19.9954Z"
        fill={color}
      />
      <path
        d="M8.70025 13.5884C9.51487 12.9932 10.0531 12.1076 10.1967 11.1264C10.3403 10.1452 10.0774 9.14866 9.46591 8.35593C8.19225 6.70082 5.42859 5.9111 3.732 7.15006C2.0354 8.38903 1.7024 11.451 2.96634 13.1014C4.23028 14.7517 7.00366 14.8274 8.70025 13.5884Z"
        fill={color}
      />
      <path
        d="M11.9841 7.50205L16.5562 5.92261L17.001 7.28925L12.2102 8.35089L11.9841 7.50205Z"
        fill={color}
      />
      <path
        d="M10.2598 5.7336L14.0686 1.34756L15.352 2.60308L10.9282 6.4382L10.2598 5.7336Z"
        fill={color}
      />
      <path
        d="M7.97827 4.42386L9.7964 0L10.7103 0.401955L8.73421 4.70287L7.97827 4.42386Z"
        fill={color}
      />
    </svg>
  );
};

export const GroupIcon = ({ color }: IconProps) => {
  return (
    <svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.7317 10.4879L17.9433 20.886C14.7144 20.774 11.374 20.7721 8.8125 20.8158L8.84712 11.6114C8.76442 9.8768 10.0663 7.69622 12.0067 7.60702L14.0683 7.51023C16.3048 7.16104 17.649 8.7533 17.7317 10.4879Z"
        fill={color}
      />
      <path
        d="M15.1694 5.73836C15.7642 5.29719 16.1573 4.64103 16.2622 3.91404C16.3672 3.18704 16.1754 2.44866 15.729 1.86113C14.7982 0.637045 12.779 0.0487237 11.5405 0.967264C10.3021 1.8858 10.0501 4.15559 10.9809 5.37778C11.9117 6.59997 13.929 6.6569 15.1694 5.73836Z"
        fill={color}
      />
      <path
        d="M4.80515 9.97745L3.26669 10.0477C1.83015 10.1141 0.860922 11.7348 0.922461 13.0253L0.897461 22.1158C2.80131 22.0855 5.28592 22.0855 7.68592 22.169L7.53015 12.1903C7.46862 10.9017 6.47438 9.71175 4.80515 9.97745Z"
        fill={color}
      />
      <path
        d="M5.65938 8.58252C6.20706 8.17677 6.56903 7.57297 6.66568 6.90389C6.76233 6.23482 6.58575 5.55525 6.17476 5.01464C5.31707 3.89113 3.4613 3.35026 2.32861 4.19478C1.19591 5.03931 0.951682 7.125 1.80745 8.2504C2.66322 9.3758 4.51899 9.42705 5.65938 8.58252Z"
        fill={color}
      />
      <path
        d="M25.581 14.6579C25.5194 13.3674 24.5194 12.1794 22.856 12.4432L21.3175 12.5153C19.879 12.5817 18.9117 14.2025 18.9752 15.493L18.9502 22.623C20.854 22.5908 23.3387 22.5927 25.7387 22.6762L25.581 14.6579Z"
        fill={color}
      />
      <path
        d="M23.5321 11.3558C23.7824 11.1704 23.9933 10.9382 24.1526 10.6724C24.312 10.4066 24.4167 10.1124 24.4608 9.80659C24.5049 9.50082 24.4875 9.18947 24.4097 8.89033C24.3318 8.59118 24.195 8.3101 24.0071 8.06314C23.2167 7.02503 21.5071 6.52591 20.4494 7.30401C19.3917 8.08211 19.186 10.0084 19.9763 11.0503C20.7667 12.0922 22.4802 12.1358 23.5321 11.3558Z"
        fill={color}
      />
    </svg>
  );
};
export const VideosIcon = ({ color }: IconProps) => {
  return (
    <svg width="41" height="33" viewBox="0 0 41 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.5139 12.26C33.9895 12.033 18.6353 8.86463 13.2056 8.23842C7.77584 7.61221 7.61034 6.68725 6.2921 11.8377C5.54588 14.7562 4.26829 21.6589 4.20151 24.7038C4.13473 27.7487 4.80836 27.7343 8.42044 28.372C13.0662 29.1907 29.0767 31.1813 31.8844 31.5605C36.2573 32.1522 37.1487 32.7871 38.0401 28.8546C38.795 25.5282 39.2015 21.1303 39.6806 18.367C40.6243 12.9092 39.5674 12.8661 35.5139 12.26ZM35.4646 29.837L6.38792 25.8987L8.72822 9.52531L37.2822 14.1989L35.4646 29.837ZM27.0703 20.2657L17.8281 24.1293L19.1463 14.3627L27.0703 20.2657ZM8.39431 5.40036L6.62602 0.47684L8.15621 0L9.34088 5.17056L8.39431 5.40036ZM6.41696 7.25601L1.50697 3.15978L2.9036 1.77522L7.20383 6.53788L6.41696 7.25601ZM4.95064 9.7149L0 7.75583L0.450058 6.77056L5.26132 8.90485L4.95064 9.7149Z"
        fill={color}
      />
    </svg>
  );
};
